// Libraries
import { action, observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";
import { isEmptyOrWhitespace } from "Core/Utils/Utils";

import { isNullOrUndefined } from "Custom/Utils/Utils"; // Custom

export class QuoteModel extends ModelBase<QuoteModel, QuoteModelDTO> {
    constructor() {
        super();
    }

    // #region Model Properties

    @observable
    public gutterProducts = observable<any>([]);

    @observable
    public roofProducts = observable<any>([]);

    // #endregion Model Properties

    @action
    public fromDto(model: QuoteModelDTO): void {
        this.gutterProducts.replace([]);
        this.roofProducts.replace([]);

        if (!isNullOrUndefined(model.gutterQuoteItems)) {
            this.gutterProducts.replace(model.gutterQuoteItems);
        }

        if (!isNullOrUndefined(model.roofQuoteItems)) {
            this.roofProducts.replace(model.roofQuoteItems);
        }
    }

    public toDto(): QuoteModelDTO {
        const gutterQuoteItems: any[] = this.gutterProducts;
        const roofQuoteItems: any[] = this.roofProducts;

        return {
            gutterQuoteItems: JSON.parse(JSON.stringify(gutterQuoteItems)),
            roofQuoteItems: JSON.parse(JSON.stringify(roofQuoteItems)),
        };
    }
}

export interface QuoteModelDTO {
    gutterQuoteItems: any[];
    roofQuoteItems: any[];
}
